import React from "react";
import { useParams } from "react-router-dom";
import ThreadList from "./components/ThreadList";
import ThreadView from "./components/ThreadView";

const Chat = () => {
  const { threadId } = useParams();
  if (threadId) return <ThreadView key={threadId} threadId={threadId} />;
  return <ThreadList />;
};

export default Chat;
